// Global packages and components
import { clsx } from 'clsx'
import { inputRadioClasses } from '~/utils'

// Types
import type { ReactNode } from 'react'

interface Props {
  name: string
  id?: string
  label: string
  value: string
  checked?: boolean
  disabled?: boolean
  children?: ReactNode
  required?: boolean
  error?: string
  onChange?: (e: string) => void
}

// Main export
const Radio = ({
  name,
  id,
  label,
  value,
  checked,
  disabled,
  children,
  required,
  error,
  onChange,
}: Props) => (
  <>
    <div
      key={value}
      className={clsx('flex items-center gap-3', {
        'cursor-pointer': !disabled,
        'cursor-not-allowed': disabled,
      })}
    >
      <input
        type="radio"
        name={name}
        id={id ?? value}
        required={required}
        value={value}
        checked={checked}
        onChange={() => (onChange ? onChange(value) : undefined)}
        className={inputRadioClasses({ disabled })}
      />
      <label
        htmlFor={id ?? value}
        className={clsx('peer-checked:font-semibold', {
          'cursor-pointer': !disabled,
          'pointer-events-none cursor-not-allowed text-gray-500': disabled,
          'font-semibold': checked,
        })}
      >
        {label}
      </label>
    </div>
    {children && (
      <div
        className={clsx('pb-4 pt-1', {
          block: checked,
          hidden: !checked,
        })}
      >
        {children}
      </div>
    )}
    {error && <p className="mb-0 pt-2 text-xs text-red-600">{error}</p>}
  </>
)

export default Radio
